import { supabase } from '../supabase/client';

export async function verknuepfeTicketMitEmail(ticketId: string, emailId: string): Promise<void> {
  const { error } = await supabase.from('entity_links').insert({
    source_type: 'ticket', source_id: ticketId, target_type: 'email', target_id: emailId, link_type: 'quelle',
  });
  if (error) throw error;
}

export async function ladeTicketsZuEmail(emailId: string): Promise<{ id: string; ticket_nummer: string }[]> {
  const [{ data: links }, { data: direkt }] = await Promise.all([
    supabase.from('entity_links').select('source_id')
      .eq('target_type', 'email').eq('target_id', emailId).eq('source_type', 'ticket').eq('link_type', 'quelle'),
    supabase.from('tickets').select('id').eq('quelle_email_id', emailId),
  ]);
  const ids = [...new Set([
    ...(links || []).map((r: any) => r.source_id),
    ...(direkt || []).map((r: any) => r.id),
  ])];
  if (ids.length === 0) return [];
  const { data: tickets } = await supabase.from('tickets').select('id, ticket_nummer').in('id', ids);
  return (tickets || []) as { id: string; ticket_nummer: string }[];
}

// Verknüpfte E-Mails eines Tickets: aus entity_links UND dem Direktfeld quelle_email_id (Union).
export async function ladeEmailsZuTicket(ticketId: string): Promise<{ id: string; betreff: string | null; von: string | null; datum: string | null }[]> {
  const { data: links } = await supabase.from('entity_links')
    .select('target_id')
    .eq('source_type', 'ticket').eq('source_id', ticketId).eq('target_type', 'email').eq('link_type', 'quelle');
  const ids = new Set<string>((links || []).map((r: any) => r.target_id));
  const { data: t } = await supabase.from('tickets').select('quelle_email_id').eq('id', ticketId).maybeSingle();
  if (t?.quelle_email_id) ids.add(t.quelle_email_id as string);
  if (ids.size === 0) return [];
  const { data: emails } = await supabase.from('emails').select('id, betreff, von, datum').in('id', [...ids]);
  return (emails || []) as { id: string; betreff: string | null; von: string | null; datum: string | null }[];
}

// Ticket↔E-Mail-Verknüpfung manuell aufheben (von beiden Seiten nutzbar):
// entfernt den entity_link UND löst das Direktfeld quelle_email_id, falls es diese E-Mail ist.
export async function loeseTicketEmailVerknuepfung(ticketId: string, emailId: string): Promise<void> {
  const { error } = await supabase.from('entity_links').delete()
    .eq('source_type', 'ticket').eq('source_id', ticketId)
    .eq('target_type', 'email').eq('target_id', emailId).eq('link_type', 'quelle');
  if (error) throw error;
  await supabase.from('tickets').update({ quelle_email_id: null }).eq('id', ticketId).eq('quelle_email_id', emailId);
}
